<template>
  <div>
    <table class="table is-fullwidth is-hoverable" ref="table">
      <thead>
        <tr>
          <th>{{ $t("module") }}</th>
          <th>{{ $t("allowed") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(mdle, midx) in modules" :key="midx">
          <td>{{ $t(mdle.code_name) }}</td>
          <td>
            <span
              class="icon has-text-success"
              v-if="mdle.system_role_modules.length"
            >
              <i class="fa fa-check"></i>
            </span>
            <span
              class="icon has-text-danger"
              v-if="!mdle.system_role_modules.length"
            >
              <i class="fa fa-ban"></i>
            </span>
          </td>
          <td>
            <p class="buttons">
              <button
                class="button is-primary is-rounded"
                @click="allow(mdle)"
                v-if="!mdle.system_role_modules.length"
              >
                <span class="icon">
                  <i class="fa fa-unlock"></i>
                </span>
                <span>{{ $t("allow") }}</span>
              </button>
              <button
                class="button is-warning is-rounded"
                @click="disallow(mdle)"
                v-if="mdle.system_role_modules.length"
              >
                <span class="icon">
                  <i class="fa fa-lock"></i>
                </span>
                <span>{{ $t("disallow") }}</span>
              </button>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </div>
</template>

<script>
import { get, put, del, generate_error_message_text } from "@/utils";

export default {
  name: "RolePermissions",
  components: {},
  data() {
    return {
      modules: [],
      role_uuid: "",
      error: "",
    };
  },
  computed: {},
  methods: {
    init() {
      let v = this;
      v.error = "";
      if (v.role_uuid) {
        get("/access/role/modules", { uuid: v.role_uuid })
          .then((r) => {
            v.error = "";
            v.modules = r;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_role_uuid(role_uuid) {
      this.role_uuid = role_uuid;
    },
    clear_role_uuid() {
      this.role_uuid = "";
      this.modules = [];
    },
    allow(mdle) {
      let v = this;
      let data = {
        role_uuid: v.role_uuid,
        module_id: mdle.module_id,
      };
      put("/access/role/module", data)
        .then(() => {
          v.init();
          v.error = "";
        })
        .catch((err) => {
          v.error = err;
        });
    },
    disallow(mdle) {
      let v = this;
      // let data = {
      //   role_uuid: v.role_uuid,
      //   module_id: mdle.module_id,
      // };
      let frst = mdle.system_role_modules[0];
      del("/access/role/module", { role_module_id: frst.role_module_id })
        .then(() => {
          v.init();
          v.error = "";
        })
        .catch((err) => {
          v.error = err;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
